import React from 'react'
import HospitalSchedule from '../../components/HospitalSchedule/HospitalSchedule'

export default function HospitalSchedulePage() {
  return (
    <HospitalSchedule/>
  )
}
